import { useEffect } from "react";

import { postTrackingData } from "@/api/endpoints/track";
import { useIntercom } from "@/hooks/useIntercom";
import { useOrganization } from "@/hooks/useOrganization";
import { EVENT } from "@/tracking_events";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Trans } from "@lingui/react/macro";
import { Button } from "@components/ui/button";
import { ExternalLinkIcon, MessagesSquareIcon } from "lucide-react";
import { getExternalPricingURL } from "@/lib/pricing";

export const MaxAlertLimitReached = () => {
  const { data: orgData } = useOrganization();
  const { has_reached_num_alert_limit = false, country } = orgData?.ok
    ? orgData.data
    : {};

  const { show } = useIntercom();

  useEffect(() => {
    has_reached_num_alert_limit &&
      postTrackingData(EVENT.ALERT_LIMIT_REACHED_VIEWED);
  }, [has_reached_num_alert_limit]);

  if (!has_reached_num_alert_limit) return null;

  return (
    <Dialog open>
      <DialogContent data-testid="limit-reached-text" showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>
            <Trans>Du har använt alla dina bevakningar</Trans>
          </DialogTitle>
          <DialogDescription>
            <Trans>
              För att följa fler ämnen, kontakta oss om att lägga till
              bevakningar på ditt konto.
            </Trans>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" asChild>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={getExternalPricingURL(country)}
            >
              <Trans>Prisdetaljer</Trans>
              <ExternalLinkIcon />
            </a>
          </Button>

          {show && (
            <Button
              type="button"
              onClick={() => {
                show();
              }}
            >
              <Trans>Kontakta oss</Trans>
              <MessagesSquareIcon />
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
